import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

interface AgentV2UserCreationStatsResponse {
  total: number,
  interaction_rate: number,
  auto_push: number,
}

export class AgentV2UserCreationStatsData {
  @Required("total cannot be empty")
  @IsNumber("total must be a number")
  total: number;

  @Required("autoPush cannot be empty")
  @IsNumber("autoPush must be a number")
  autoPush: number;
  
  @Required("interactionRate cannot be empty")
  @IsNumber("interactionRate must be a number")
  interactionRate: number;
}

const transformAndValidateData = (
  response: AgentV2UserCreationStatsResponse
): AgentV2UserCreationStatsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2UserCreationStatsData);
  } catch (error) {
    console.error("Agent v2 user creation stats data validation failed:", error.message);
    throw error;
  }
};

/** 用户制作统计接口 */
export const agentV2UserCreationStats = async (agentId: string): Promise<AgentV2UserCreationStatsData> => {
  const res = await api.post<AgentV2UserCreationStatsResponse>('/agent-v2/user-creation-stats', {
    agent_id: agentId,
  });
  const data = transformAndValidateData(res.data);
  return data;
}